module.exports = __webpack_public_path__ + "img/coupon_6.cbaebf89.png";